import React from 'react'
import logo from '../Assests/bankshoppy1.png'
import { Link } from 'react-router-dom'
import  { useEffect, useState } from 'react';
import axios from 'axios';
import compare from '../Assests/compare.png'
import LogoT1 from "./logot1.png"
import LogoT2 from "./logot2.png"

export default function Header() {
const [laonData,setLoanData]=useState([])
const [investmentData,setInvestmentData]=useState([])
const fetchLoanData=()=>{
  axios.get("https://api.dremerz.net/api/bankshoppyloan")
  .then((res)=>{
    console.log(res.data)
    setLoanData(res.data)
  })
  .catch((err)=>{
    console.log(err)
  })

  axios.get("https://api.dremerz.net/api/bankshoppyinvestment")
  .then((res)=>{
    console.log(res.data)
    setInvestmentData(res.data)
  })
  .catch((err)=>{
    console.log(err)
  })
}

useEffect(()=>{
  fetchLoanData()
},[])


  return (
    <header className="header">
    <div className="header-menu header-menu-2" id="sticky">
      <nav className="navbar navbar-expand-lg ">
        <div className="container">
          <Link  to={"/"} className="navbar-brand"  >
            <img
              src={LogoT2} style={{width:"200px",gap:"10px"}}
            //   srcSet="img/logo/Logo-2@2x.png 2x"
              alt="logo"
            />
            {/* <span className='nav-logotext' >BankShoppy</span> */}
          </Link>
          <button
            className="navbar-toggler collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="menu_toggle">
              <span className="hamburger">
                <span />
                <span />
                <span />
              </span>
              <span className="hamburger-cross">
                <span />
                <span />
              </span>
            </span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav menu ms-auto">
              <li className="nav-item dropdown submenu ">
                
                <Link to='/'
                  href="#"
                  className="nav-link dropdown-toggle active"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Home
                </Link>
                

              </li>
              <li className="nav-item dropdown submenu">
               <div 
                  className="nav-link"
                 
                
                >
                  Loan
                </div>
                <i
                  className="arrow_carrot-down_alt2 mobile_dropdown_icon"
                  aria-hidden="false"
                  data-bs-toggle="dropdown"
                />
               <ul className="dropdown-menu"> 
               {laonData?.map((data)=>{
return(

                  <li key={data.id} className="nav-item">
                    <Link to='/loan' state={data} className="nav-link" href="loan.html">
                     {data.loanName}
                    </Link>
                  </li>
            
)

               })} 

               </ul>
              </li>
              <li className="nav-item dropdown submenu">
               <div 
             
                  className="nav-link"

                >
                 Investments
                </div>
                <i
                  className="arrow_carrot-down_alt2 mobile_dropdown_icon"
                  aria-hidden="false"
                  data-bs-toggle="dropdown"
                />
               <ul className="dropdown-menu"> 
               {investmentData?.map((data)=>{
return(

                  <li key={data.id} className="nav-item">
                    <Link to='/investments' state={data} className="nav-link" href="loan.html">
                     {data.loanName}
                    </Link>
                  </li>
            
)

               })} 

               </ul>
              </li>
           
              <li className="nav-item dropdown submenu">
                <Link to='/compare'
                  className="nav-link dropdown-toggle"
                  href="blog.html"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Compare
                </Link>
                </li>
            </ul>
            <a
              className="theme-btn"
               onClick={()=>{

               }}
            >
              Contact Us
            </a>
            {/* <ui >
              <li className="nav-item" style={{paddingLeft:"50px"}} >
              <img  src={compare } alt="compare"  width='40' height='40' />

              </li>
            </ui> */}
          
          </div>
        </div>
      </nav>
    </div>
  </header>
  
  )
}
